import React from "react";
import { Platform } from "react-native";

import { useMessageContext } from "../../context/messaging/StreamContext";

import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import {
  type PlaceholderChannelProps,
  type PlaceholderThreadProps,
} from "@/schemas/messaging/stream";

let ChannelComponent: React.FC<PlaceholderChannelProps>;
let ThreadComponent: React.FC<PlaceholderThreadProps>;

if (Platform.OS !== "web") {
  const { Channel, Thread } = require("stream-chat-expo"); // eslint-disable-line @typescript-eslint/no-var-requires
  ChannelComponent = Channel;
  ThreadComponent = Thread;
}

function ThreadScreen(): React.JSX.Element {
  const { channel, thread } = useMessageContext();

  if (channel !== undefined && channel !== null) {
    return (
      <ScreenLayout isLoading={false}>
        <ChannelComponent channel={channel} thread={thread ?? null}>
          <ThreadComponent />
        </ChannelComponent>
      </ScreenLayout>
    );
  }
  return <></>;
}

export default ThreadScreen;
